import { Paper, Popper, styled } from '@mui/material'

export const SchedulePickerClockPaper = styled(Paper)({
  '& .PrivateClockNumber-disabled': {
    display: 'none',
    pointerEvents: 'none',
  },
  '& [class*="ClockNumber"][class*="disabled"]': {
    display: 'none',
    pointerEvents: 'none',
  },
})

export const SchedulePickerClockPopper = styled(Popper)({
  '& .PrivateClockNumber-disabled': {
    display: 'none',
    pointerEvents: 'none',
  },
  '& [class*="ClockNumber"][class*="disabled"]': {
    display: 'none',
    pointerEvents: 'none',
  },
})

export const scheduleTimePickerDialogProps = {
  PaperProps: {
    component: SchedulePickerClockPaper,
  },
} as Record<string, unknown>

export const scheduleTimePickerPopperProps = {
  component: SchedulePickerClockPopper,
} as Record<string, unknown>
